import Message from './components/Message/Message';
import { useBroadcast } from './hooks/useBroadcast';
import Advt from './components/Advt/Advt';
import bgVideo from './assets/video/bgYARDS.mp4';
import poster from './assets/images/poster.png';

function App() {
  const {
    isVisible,
    currentMessage,
    currentState,
    // showedMessages,
    isVertical,
    // currentMessageWinner,
  } = useBroadcast();

  return (
    <div className="app-wrapper">
      <div className="titre-wrapper">
        <div className="advtWrapper">
          <Advt />
        </div>
        {isVisible && currentState === 'S1' && (
          <div className="message-wrapper">
            {currentMessage && (
              <Message
                currentMessage={currentMessage}
                isVertical={isVertical}
              />
            )}
          </div>
        )}
      </div>
      <video
        autoPlay="autoplay"
        muted="muted"
        loop
        poster={poster}
        id="bgVideo">
        <source src={bgVideo} type="video/mp4"></source>
      </video>

      <div id="img-loader"></div>
    </div>
  );
}

export default App;
